import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { ReferenceDot } from "recharts";
import AnnotationInner from "./AnnotationInner";

const Annotation = ({
  x,
  y,
  chartWidth,
  textLabels,
  arrowLineWidth,
  bottomPadding,
  forceLeft,
  collisionXPos,
}) => {
  const [labelDims, setLabelDims] = useState({});
  const elLabel = useRef(null);
  let rightAlign = true;
  if (labelDims.right + 20 > chartWidth || forceLeft) {
    rightAlign = false;
  }
  let curve = true;
  if (collisionXPos && collisionXPos > x) {
    curve = false;
  }

  return (
    <ReferenceDot
      ifOverflow="extendDomain"
      ref={elLabel}
      x={x}
      y={y}
      r={1}
      fill={null}
      width={1}
      height={1}
      fillOpacity={0}
      label={{
        fontSize: 14,
        position: "right",
        content: (
          <AnnotationInner
            chartWidth={chartWidth}
            setLabelDims={setLabelDims}
            rightAlign={rightAlign}
            textLabels={textLabels}
            arrowLineWidth={arrowLineWidth}
            bottomPadding={bottomPadding}
            curve={curve}
          />
        ),
      }}
      stroke={null}
    />
  );
};

Annotation.defaultProps = {
  arrowLineWidth: null,
  bottomPadding: null,
  forceLeft: false,
  collisionXPos: null,
};

Annotation.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  chartWidth: PropTypes.number.isRequired,
  textLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
  arrowLineWidth: PropTypes.number,
  bottomPadding: PropTypes.number,
  forceLeft: PropTypes.bool,
  collisionXPos: PropTypes.number,
};

export default Annotation;
